import Shipment from './Shipment.js';

export default Shipment;